import { HttpBackend } from '@angular/common/http'
import { importProvidersFrom } from '@angular/core'

import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader'

import { TranslateLoader, TranslateModule } from '@ngx-translate/core'

export const httpTranslateLoader = (http: HttpBackend) => {
  return new MultiTranslateHttpLoader(http, [
    { prefix: '/assets/yoshu-lib/i18n/', suffix: '.json' },
    { prefix: '/assets/i18n/', suffix: '.json' }
  ])
}

/**
 * Provides the translation module configuration for the application.
 *
 * This function sets up the `TranslateModule` with a custom loader and a default language.
 * It uses the `httpTranslateLoader` function as the factory for the `TranslateLoader`,
 * which depends on the `HttpClient` service.
 *
 * @returns The providers for the `TranslateModule` configured with the specified loader and default language.
 */
export const provideTranslate = () => {
  return importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpBackend]
      },
      defaultLanguage: 'en'
    })
  )
}
